import "./dropdowns.css";
import { routes } from "../../routes";
import { useNavigate } from "react-router-dom";
import { useRef, useEffect, useState } from "react";
import { logout } from "../../redux/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { profileImages } from "../../utils/globalImages";
import battle1 from "../../assets/images/Battles/battle1.png";
import { togglePayment } from "../../redux/slices/accountSlice";
import { ReactComponent as KYC } from "../../assets/drawings/KYCBadge.svg";
import { ReactComponent as ShoppingCart } from "../../assets/icons/cart.svg";
import ArrowProgressBar from "../../../src/components/common/ProgressBar/ArrowProgressBar.jsx";

function Profile({ isDarkMode }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state?.auth?.user);
  const userAccount = useSelector((state) => state?.account);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Check if screen is mobile (768px or less)
    const isMobile = window.innerWidth <= 768;

    if (showDropdown && isMobile) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    };
  }, [showDropdown]);

  const openWithdrawModal = () => {
    setShowDropdown(false);
    dispatch(togglePayment({ payment: true }));
  };

  const handleLogout = () => {
    setShowDropdown(false);
    dispatch(logout());
  };

  return (
    <>
      <div ref={dropdownRef} className="custom-dropdown-container">
        <button
          style={{ boxShadow: "none" }}
          className={`avatar-toggle custom-toggle px-0 ${
            isDarkMode
              ? "dark-mode custom-toggle-dark dark"
              : "custom-toggle-light light"
          }`}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          <img src={user?.userdetails?.avatar || battle1} alt="User Avatar" />
        </button>

        {showDropdown && (
          <div className="profile-dropdown-main px-3 pt-4 pb-4">
            <div
              style={{
                inset: 0,
                opacity: 0.15,
                position: "absolute",
                filter: "brightness(0.7)",
                backgroundColor: "#262626",
              }}
            />
            <div
              className="container"
              style={{ position: "relative", zIndex: 1, padding: "0px 20px" }}
            >
              <div className="row">
                <div className="col-8">
                  <div className="row ">
                    <div className="col-3 p-0">
                      <img
                        alt="User Avatar"
                        src={
                          user?.userdetails?.avatar
                            ? user?.userdetails?.avatar
                            : profileImages.userAvatarReplacement
                        }
                        className="profile-avatar"
                      />
                    </div>
                    <div className="col-9 ms-2 ms-lg-0 mt-lg-2 ps-0">
                      <p
                        className="header-title d-start gap-10px mb-1"
                        style={{
                          color: !isDarkMode && "#fff",
                          fontSize: "18px",
                        }}
                      >
                        {user.userdetails.username}
                        {user?.kyc && <KYC className="kyc-icon" width={50} />}
                      </p>
                      <p className="header-subtitle">{user.email}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row user-xp-outer mt-3">
                <ArrowProgressBar user={userAccount} isProfile={true} />
              </div>

              <div
                className="row  cursor-pointer profile-outer mt-3"
                onClick={() => {
                  setShowDropdown(false);
                  navigate(routes.ACCOUNT);
                }}
              >
                <div className="col-6 d-start">
                  <i
                    aria-hidden="true"
                    className="fa fa-user text-light-gray text-19x"
                  ></i>
                  <span className="text-light-gray m-icon-left">Profile</span>
                </div>
              </div>

              <div
                className="row cursor-pointer mt-2 cart-outer"
                onClick={() => {
                  setShowDropdown(false);
                  navigate(routes.CART);
                }}
              >
                <div className="col-6 d-start text-light-gray">
                  <ShoppingCart width={20} height={20} />
                  <span className="m-icon-left">Cart</span>
                </div>
              </div>

              <div
                className="row cursor-pointer logout-outer mt-2"
                onClick={handleLogout}
              >
                <div className="col-6 d-start text-light-gray">
                  <img src={profileImages.logout} alt="Logout Image" />
                  <span className="m-icon-left">Logout</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Profile;
